module.exports = __webpack_public_path__ + "static/Zoo-1f741a72892bd628865048dda63500b7.jpg";